import { render } from "./ActivityManagement.vue?vue&type=template&id=1c243a5e&scoped=true"
import script from "./ActivityManagement.vue?vue&type=script&lang=js"
export * from "./ActivityManagement.vue?vue&type=script&lang=js"

import "./ActivityManagement.vue?vue&type=style&index=0&id=1c243a5e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c243a5e"]])

export default __exports__